(function () {
  'use strict';

  angular.module('wsLrs.directives').
  // Attributes:
  //  card: if provided, takes precedence over cardId
  //  title: can be used to override the card.title - SHOULD NOT BE USED UNLESS REQUIRED BY CLIENT
  //  cardId: can be used to specify this card, only if 'card' is not provided
  directive('wsDetailHeader', ['AppPermissions', 'Demo', 'ShareKeyHelper', 'ShareNav', 'CardRegistry', '$rootScope', 'OrganizationSettings', 'User', 'UserRoles', 'ViewDashboardsAs', 'wsEventNames', '$window', 'ShareUtils', 'QuickFilters', function (AppPermissions, Demo, ShareKeyHelper, ShareNav, CardRegistry, $rootScope, OrganizationSettings, User, UserRoles, ViewDashboardsAs, wsEventNames, $window, ShareUtils, QuickFilters) {
    return {
      templateUrl: "modules/common/directives/card-detail-header/card-detail-header.html",
      scope: {
        card: "=?",
        title: "=?",
        cardId: "=?",
        preview: "=?",
        subDetails: "=?"
      },
      link: function link(scope) {
        scope.viewDashboard = ViewDashboardsAs;

        // For any callbacks that are strings, change them into functions that
        // navigate to those strings. This could be the case when a download link
        // is the callback but we're just passing in a string to the location to get
        // said download link.
        if (scope.subDetails) {
          scope.subDetails.forEach(function (subDetail) {
            if (typeof subDetail.callback === 'string') {
              var url = subDetail.callback;
              subDetail.callback = function () {
                return $window.location = url;
              };
            }
          });
        }
        if (scope.cardId && !scope.card) {
          scope.card = CardRegistry.get(scope.cardId);
        } else {
          scope.cardId = scope.card.id;
        }
        scope.$watch('viewDashboard.isActive', function (newVal, oldVal, scope) {
          scope.showDetailHeader = !newVal;
        });
        scope.title = scope.title || scope.card.title;
        scope.sharesCount = scope.card.shareCount;
        scope.subDetails = scope.subDetails || [];
        var previewMode = scope.preview || scope.cardId === "preview";
        if (previewMode) {
          $rootScope.$on(wsEventNames.explorer.change.cardTitle, function (evt, title) {
            scope.title = title;
          });
          $rootScope.$on(wsEventNames.explorer.change.cardDescription, function (evt, description) {
            scope.card.description = description;
          });
        }
        var isNotShare = User.get().user !== undefined && User.get().user;

        // Only do this if real, not somebody looking at a share
        if (isNotShare) {
          if (scope.cardId !== 'preview' && OrganizationSettings.hasFeature("quickFilters")) {
            var quickFilters = scope.card.configuration.quickFilters;
            if (_.isEmpty(quickFilters)) {
              //get defaults
              quickFilters = OrganizationSettings.hasFeature("defaultQuickFilters");
            }
            var anyQuickFiltersEnabled = QuickFilters.hasAnyQuickFiltersEnabled(quickFilters);
            if (anyQuickFiltersEnabled) {
              scope.filterCfg = {
                showFilter: false,
                cardConfig: scope.card.configuration,
                quickFilters: quickFilters
              };
              scope.subDetails.push({
                text: 'Quick Filters',
                href: null,
                tooltip: 'Quick filters',
                callback: function callback() {
                  scope.filterCfg.showFilter = !scope.filterCfg.showFilter;
                }
              });
            }
          }
          AppPermissions.getForUser({
            value: 'explorer'
          }).then(function (permissions) {
            if (scope.card.template.explorable && !ShareKeyHelper.hasShareKey() && !previewMode) {
              if (UserRoles.isOrgAdmin(User.get()) || permissions.length) {
                if (OrganizationSettings.hasFeature("configureCard") || Demo.isDemoMode()) {
                  scope.subDetails.push({
                    text: "Configure",
                    href: null,
                    tooltip: 'Configure',
                    callback: function callback() {
                      $rootScope.$broadcast("explore-card", {
                        cardId: scope.cardId
                      });
                    }
                  });
                }
              }
            }
          });
        }
        scope.showSharesCount = false;
        if (!previewMode) {
          ShareNav.updateNav(scope).then(function (subDetail) {
            if (subDetail) {
              scope.showSharesCount = scope.sharesCount > 0;
              scope.subDetails.unshift(subDetail);
            }
          });
        }

        // Hide Download Data Tables if not permitted
        if (isNotShare) {
          _.each(scope.subDetails, function (subDetail) {
            // If a regular report, simply see if the org allows download of data
            if (subDetail.downloadData && !OrganizationSettings.hasFeature("downloadData")) {
              subDetail.hide = true;
            }
            if (subDetail.text.indexOf("interaction") > -1 && !OrganizationSettings.hasFeature("downloadInteractions")) {
              subDetail.hide = true;
            }
          });
        } else {
          ShareUtils.getShare().then(function (share) {
            _.each(scope.subDetails, function (subDetail) {
              // If it's a share, check for the download data feature by directly looking at
              // the org, and ignoring the current user.  Also, hide interaction downloads
              if (subDetail.downloadData && !share.allowDataDownload) {
                subDetail.hide = true;
              } else if (subDetail.text.indexOf("interaction") > -1) {
                subDetail.hide = true;
              }
            });
          });
        }
        $rootScope.$on(wsEventNames.dataTable.updateSort, function (evt, orderBy) {
          var dataDownload = _.findWhere(scope.subDetails, {
            text: 'Download data',
            downloadData: true
          });
          if (dataDownload && orderBy && dataDownload.href) {
            dataDownload.href = dataDownload.href.replace(/&order_by.*/, '') + '&order_by=' + encodeURI(orderBy);
          }
        });
        $rootScope.$on('share-count-changed', function (event, args) {
          scope.sharesCount = args;
        });
        scope.normalizeText = function (text) {
          return text.toLowerCase().replace(/ /g, '-');
        };
        scope.getSubDetailHref = function (_ref) {
          var text = _ref.text,
            href = _ref.href;
          var DIRECTIVE_DEFERRED = ['download-data-tables', 'download-data'];
          var isHandledByDataDownloadIndicator = DIRECTIVE_DEFERRED.includes(scope.normalizeText(text)) && href.indexOf("/activity/csv") === -1;
          if (isHandledByDataDownloadIndicator) {
            return "";
          }
          return href ? href : "";
        };
      }
    };
  }]);
})();
